import React, { useState } from "react";
import "./style.css";
import { AiOutlineDown, AiOutlineRight } from "react-icons/ai";
import { useNavigate } from "react-router-dom";

const PageContentOverView = ({selectedHeading, subHeadingCount, toggleSubheading, openSubheadingId, currPageContent, setTertiaryId}) => {
  const [selectedTertiary, setSelectedTertiary] = useState(null);
  const navigate = useNavigate();
  const handleTertiaryData = (data) => {
    setTertiaryId(data._id); // Pass the tertiary ID
    setSelectedTertiary(data._id); // Update the selected tertiary state
    navigate(`/help/${data._id}`);
  };

  const handleSubheadingClick = (dataId, subId, sub) => {
    toggleSubheading(dataId, subId, sub);
    // Check if the subheading has tertiary subheadings
    if (sub.tertiarySubHeadings && sub.tertiarySubHeadings.length > 0) {
      const firstTertiary = sub.tertiarySubHeadings[0];
      handleTertiaryData(firstTertiary); // Set default tertiary ID
    } else {
      // Clear tertiary selection if no tertiary subheadings
      setSelectedTertiary(null);
      setTertiaryId(null);
    }
  };

  return (
    <div className="flex h-[94%] w-full bg-[#fff]">
      <div className="w-[79%] flex flex-col items-start pt-[10%] h-full px-[4%] overflow-auto">
        {selectedHeading ? (
          <div className="w-[80%] mx-auto  mb-4">
            <h1 className="text-[#505256] FontFamily-Avenir text-4xl">{selectedHeading.heading}</h1>
           
            <div className="pt-6">
              {selectedHeading.subHeadings.map((subHeadingData, index) => (
                <div className="my-2" key={subHeadingData._id}>
                  <div className="h-14 w-[74%] flex items-center  text-[#707070] border px-4 rounded-xl py-3 hover:bg-gray-100">
                    <button
                      className="w-full text-left  text-base leading-6 FontFamily-Avenir-reg"
                      onClick={() =>
                        handleSubheadingClick(
                          selectedHeading._id,
                          subHeadingData._id,
                          subHeadingData
                        )
                      }
                    >
                      {subHeadingData.subHeading}
                    </button>
                    {openSubheadingId === `${selectedHeading._id}-${subHeadingData._id}` ? (
                      <AiOutlineDown className="text-sm" />
                    ) : (
                      <AiOutlineRight className="text-sm" />
                    )}
                  </div>
                  {openSubheadingId === `${selectedHeading._id}-${subHeadingData._id}` && (
                    <div className="py-2">
                      {subHeadingData.tertiarySubHeadings.map((tertiaryHeading) => (
                        <div onClick={() => handleTertiaryData(tertiaryHeading)} key={tertiaryHeading._id}
                          className={`text-sm hover:text-[#57a5e0] border-l hover:border-[#57a5e0] border-[#e5e7ea] text-left pl-2 py-[.6rem]  cursor-pointer capitalize`}
                        >
                          <div className="text-[#707070] h-full">
                            <div className="w-full h-auto text-left flex flex-col items-start justify-start MainContent-helper"
                              dangerouslySetInnerHTML={{__html: currPageContent}}
                            ></div>
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        ) : (
          <p>Select a heading from the sidebar to see the content.</p>
        )}
      </div>
    </div>
  );
};

export default PageContentOverView;
